import { useQueryClient as _, useQuery as S, useInfiniteQuery as Y } from "@tanstack/react-query";
import { COMMON_DATA_FILES_API_BASE_PATH as v, DATA_FILES_API_BASE_PATH as O } from "../../file-uploader/api/index.mjs";
import { PaginationOrderEnum as R } from "../../../enums/pagination-enums.mjs";
import { httpClient as b } from "../../../utils/http-client.mjs";
const $ = async ({
  startFrom: m,
  limit: o,
  order: r,
  sortColumn: c,
  sortDirection: a,
  filter: e,
  fileManagerApiType: s
}) => {
  var C, u;
  const I = () => s != null && s.isCommon ? v : O;
  return (await b.get(
    I() + "?" + (e != null && e.name ? `&filter[names][]=${e == null ? void 0 : e.name}` : "") + ((C = e == null ? void 0 : e.source) != null && C.length ? e.source.map((d) => `&filter[sources][]=${encodeURIComponent(d)}`).join("") : "") + ((u = e == null ? void 0 : e.type) != null && u.length ? e.type.map((d) => `&filter[types][]=${encodeURIComponent(d)}`).join("") : "") + (m ? `&pagination[startFrom]=${m}` : "") + (c ? `&pagination[sortColumn]=${c}` : "") + (a ? `&pagination[sortDirection]=${a}` : "") + (o ? `&pagination[limit]=${o}` : "") + (r ? `&pagination[order]=${r}` : "")
  )).data;
}, B = ({
  startFrom: m,
  limit: o = 10,
  order: r = R.Next,
  sortColumn: c,
  sortDirection: a,
  filter: e,
  fileManagerApiType: s
}, I) => {
  const i = _(), u = s != null && s.isCommon ? "common-data-files" : s != null && s.isPublic ? "public-data-files" : "data-files", d = [u], K = [
    u,
    { startFrom: m, limit: o, order: r, sortColumn: c, sortDirection: a, filter: e }
  ];
  return {
    ...S({
      queryKey: K,
      queryFn: () => $({ startFrom: m, limit: o, order: r, sortColumn: c, sortDirection: a, filter: e, fileManagerApiType: s }),
      ...I
    }),
    resetAndRefetch: () => {
      i.invalidateQueries({ queryKey: d });
    },
    triggerFetch: () => {
      i.fetchQuery({ queryKey: K });
    },
    deleteItemFromData: (h) => {
      i.getQueryCache().findAll({ queryKey: d }).forEach((P) => {
        i.setQueryData(
          P.queryKey,
          (q) => {
            if (q)
              return {
                ...q,
                items: q.items.filter((F) => F.id !== h)
              };
          }
        );
      });
    },
    renameItemFromData: ({ id: h, name: Q }) => {
      i.getQueryCache().findAll({ queryKey: d }).forEach((q) => {
        i.setQueryData(
          q.queryKey,
          (F) => {
            if (F)
              return {
                ...F,
                items: F.items.map((E) => E.id === h ? { ...E, name: Q } : E)
              };
          }
        );
      });
    }
  };
}, j = ({
  limit: m = 10,
  order: o = R.Next,
  sortColumn: r,
  sortDirection: c,
  filter: a,
  fileManagerApiType: e
}, s) => {
  const I = _(), u = [e != null && e.isCommon ? "common-infinite-data-files" : e != null && e.isPublic ? "public-infinite-data-files" : "infinite-data-files", { limit: m, order: o, sortColumn: r, sortDirection: c, filter: a }];
  return { ...Y({
    initialPageParam: void 0,
    queryKey: u,
    queryFn: ({ pageParam: n }) => $({
      startFrom: typeof n == "string" ? n : void 0,
      limit: m,
      order: o,
      sortColumn: r,
      sortDirection: c,
      filter: a,
      fileManagerApiType: e
    }),
    getPreviousPageParam: (n) => {
      if (!n.hasMore) return;
      const t = n.items[0];
      if (t)
        return encodeURIComponent(
          JSON.stringify({
            id: t.id,
            field: t[r ?? "name"]
          })
        );
    },
    getNextPageParam: (n) => {
      if (!n.hasMore) return;
      const t = n.items[n.items.length - 1];
      if (t)
        return encodeURIComponent(
          JSON.stringify({
            id: t.id,
            field: t[r ?? "name"]
          })
        );
    },
    ...s
  }), resetAndRefetch: () => {
    I.invalidateQueries({ queryKey: u });
  }, deleteItemFromData: (n) => {
    I.setQueryData(u, (t) => t && {
      ...t,
      pages: t.pages.map((y) => ({
        ...y,
        items: y.items.filter((h) => h.id !== n)
      }))
    });
  }, renameItemFromData: ({ id: n, name: t }) => {
    I.setQueryData(u, (y) => y && {
      ...y,
      pages: y.pages.map((h) => ({
        ...h,
        items: h.items.map((Q) => Q.id === n ? { ...Q, name: t } : Q)
      }))
    });
  } };
};
export {
  B as useDataFiles,
  j as useInfiniteDataFiles
};
